// Bridge from the (non-React) business API layer to the shell for the lapse
// policy's safety net: parseEnvelope reports every 403 `business_read_only`
// response here, and LiveBusinessShell subscribes to surface a consistent
// toast + refresh the tenant list (so access_mode flips and the central
// mutability gate catches up). Throttled so a burst of failing mutations
// produces a single toast.

type Listener = () => void;

const THROTTLE_MS = 5000;

let listeners = new Set<Listener>();
let lastNotifiedAt = 0;

/** Subscribe to read-only rejections; returns the unsubscribe function. */
export function subscribeBusinessReadOnly(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Called by the API layer on a 403 business_read_only response. */
export function notifyBusinessReadOnly(): void {
  const now = Date.now();
  if (now - lastNotifiedAt < THROTTLE_MS) return;
  lastNotifiedAt = now;
  listeners.forEach(listener => listener());
}

/** Test hook — clears listeners and the throttle window. */
export function resetBusinessReadOnlyNotifier(): void {
  listeners = new Set();
  lastNotifiedAt = 0;
}
